import logo from "../../../assets/illustrations/signal-AI.png"
import defineStars from "../../../assets/illustrations/definestars.png"
import "../signal.css"
import StarRating from "./rating"
import { useEffect, useState } from "react"
import { downloadPdf } from "../../../Services/APIs/report"
import { calculateCavityScore, calculateTartarScore, calculateGapScore, calculateGumScore } from "../../../Utils/signalAIScoreCalculation"
import { postLogDetails } from "../../../Services/APIs/appDetails"

const Summary = () => {
    const [downloadStatus, setDownloadStatus] = useState("ဖုန်းထဲတွင်သိမ်းထားမည်");
    const [analysisData, setAnalysisData] = useState([]);
    const uid = JSON.parse(localStorage.getItem("usertpi") || '{}').usertpi
    const app = JSON.parse(localStorage.getItem("companyBucket") || "{}").companyBucket

    useEffect(() => {
        postLogDetails({ uid, app, payLoad: `Summary page loaded` })
        // Get data once and pass as parameters for better performance
        const tpscore = JSON.parse(localStorage.getItem("tpscore") || "{}");

        // Check if tpscore data is valid
        if (!tpscore || Object.keys(tpscore).length === 0) {
            setAnalysisData(null); // Set to null to indicate error state
            return;
        }

        const cavityScore = calculateCavityScore(tpscore);
        const tartarScore = calculateTartarScore(tpscore);
        const gapScore = calculateGapScore(tpscore);
        const gumScore = calculateGumScore(tpscore);

        // Check if any score calculation failed
        if (cavityScore === null || tartarScore === null || gapScore === null || gumScore === null) {
            setAnalysisData(null); // Set to null to indicate error state
            return;
        }

        const data = [
            {
                name: "cavity",
                header: "သွားပိုးပေါက်",
                description: "သွားပိုးပေါက်တွေကမကုသပဲထားလျှင် ပိုမိုဆိုးရွားတဲ့နာကျင်မှုများနဲ့ပိုးဝင်ခြင်းများဖြစ်နိုင်ပါတယ်။",
                score: cavityScore
            },
            {
                name: "tartar",
                header: "သွားကျောက်တည်ခြင်",
                description: "သွားကျောက်များလာလျှင် သွားပိုးပေါက်နဲ့သွားဖုံးရောဂါများဖြစ်နိုင်ပါတယ်။",
                score: tartarScore
            },
            {
                name: "gaps_poorly_aligned_teeth",
                header: "သွားဖုံးရောင်ရမ်းခြင်",
                description: "သွားဖုံးရောင်ရမ်းမှုဆိုးရွားလာလျှင် သွားဖုံးရောဂါနှင့်ပိုးဝင်ခြင်းဖြစ်နိုင်ချေရှိနိုင်ပါတယ်။",
                score: gapScore
            },
            {
                name: "gum",
                header: "သွားကျဲ/မညီညာခြင်",
                description: "သွားများမညီမညာမှု ပြင်းထန်လာလျှင် မေးရိုးနာကျင်ခြင်းနှင့် အခြားသော သွားပြသာနာများကို ဖြစ်စေနိုင်ပါတယ်။",
                score: gumScore
            }
        ]

        setAnalysisData(data);
    }, [])

    const download = async () => {
        setDownloadStatus("ဒေါင်းလုပ်ဆွဲနေသည်...");
        postLogDetails({ uid, app, payLoad: `Download report clicked` })
        const file = localStorage.getItem("pdf");
        if (file) {
            const company = JSON.parse(localStorage.getItem("companyBucket") || "{}").companyBucket;
            const uid = JSON.parse(localStorage.getItem("usertpi"))?.usertpi;

            await downloadPdf({ file, company, uid })
                .then((response) => {
                    const url = response.data?.data?.info;
                    const link = document.createElement("a");
                    link.href = url;
                    link.download = file;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    setDownloadStatus("ဒေါင်းလုပ်ဆွဲပြီးပါပြီ");
                    setTimeout(() => {
                        setDownloadStatus("ဖုန်းထဲတွင်သိမ်းထားမည်");
                    }, 2500);
                })
                .catch((error) => {
                    setDownloadStatus("ပြုလုပ်မရပါ ပြန်လည်ကြိုးစားပါ...");
                    setTimeout(() => {
                        setDownloadStatus("ဖုန်းထဲတွင်သိမ်းထားမည်");
                    }, 2500);
                });
        } else {
            setDownloadStatus("ရှာမတွေ့ပါ");
            setTimeout(() => {
                setDownloadStatus("ဖုန်းထဲတွင်သိမ်းထားမည်");
            }, 2500);
        }
    };


    return (
        <div className="signal-ai-bg-image h-full w-full ">
            <img src={logo} alt="Signal AI" className="w-2/5 mx-auto" />
            <div className="bg-gradient-to-t from-[#eeeff0] to-transparent w-10/12 mx-auto px-5 py-10">
                {
                    analysisData === null ? (
                        // Error state - show server busy message
                        <div className="flex flex-col items-center justify-center py-10">
                            <div className="text-center">
                                <h2 className="text-xl font-bold text-signal-ai-blue mb-4">
                                    အင်တာနက်ချို့ယွင်းနေပါသည်။ ပြန်လည်ကြိုးစားပါ။

                                </h2>
                                <p className="text-lg text-signal-ai-blue mb-6">
                                    ကျေးဇူးပြုပြီး ခဏအနည်းငယ်စောင့်ပေးပါ
                                </p>
                                <button
                                    onClick={() => window.location.reload()}
                                    className="bg-signal-ai-secondary text-white px-6 py-3 rounded-md mx-auto"
                                >
                                    နောက်သို့
                                </button>
                            </div>
                        </div>
                    ) : (
                        // Normal state - show analysis data
                        analysisData.map((item, index) => (
                            <div key={index} className="text-lg">
                                <div className="flex">
                                    <h2 className="text-lg font-bold text-signal-ai-blue">{item.header}: </h2>
                                    <StarRating score={item.score} />
                                </div>
                                <p className="text-signal-ai-blue mt-1 mb-5">{item.description}</p>
                            </div>
                        ))
                    )
                }

                {analysisData !== null && <> <img src={defineStars} alt="Define Stars" className="w-full mx-auto" />
                    <div className=" flex text-[15px] text-signal-ai-red font-medium">
                        <p className=" whitespace-nowrap  me-4">အကြံပြုချက် ။  </p>
                        <p>   ။ မနက်ည(၂)ခါသွားပုံမှန်တိုက်ခြင်းဖြင့်သင့်သွားကျန်းမာရေးကို ကြိုတင်ဂရုစိုက်နိုင်ပါတယ်။ </p>
                    </div></>}

            </div>
            {analysisData !== null && (
                <>
                    <p className="mx-10 text-signal-ai-blue mt-2">စစ်ဆေးချက်အပြည့်အစုံကို ဒေါင်းလုပ်ဆွဲပြီးအသေးစိတ်ကြည့်ရှုလိုက်ပါ။</p>
                    <div className="flex">
                        <button
                            onClick={download}
                            className="bg-signal-ai-secondary text-white px-4 py-2 rounded-md mt-5 mx-auto mb-10"
                        >
                            {downloadStatus}
                        </button>
                    </div>
                </>
            )}
        </div>
    )
}

export default Summary